import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidPhoneIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19.4 13c-.2 0-.4-.1-.7-.1-.4-.1-.9-.2-1.3-.4-1-.3-2 .1-2.5 1l-.2.5c-2-1.1-3.6-2.7-4.7-4.7l.5-.3c.9-.4 1.4-1.5 1-2.5-.2-.4-.3-.9-.4-1.3 0-.2-.1-.4-.1-.7C10.8 3.1 9.5 2 8 2H5c-.9 0-1.7.4-2.2 1-.6.7-.8 1.6-.7 2.5.5 4.2 2.4 8 5.4 11 3 3 6.9 4.9 11 5.4.9.1 1.7-.2 2.4-.7.6-.6 1-1.4 1-2.2v-3c0-1.6-1-2.8-2.5-3Z"/>
  </SvgIcon>
}

export default SolidPhoneIcon
